export default () => {
	let env = process.env.REACT_APP_ENVIRONMENT;
	let baseUrl = 'https://prod.ocinsights.ai:443';

	console.log('BaseUrl: ', baseUrl, 'REACT_APP_ENVIRONMENT: ', env);
	return baseUrl;
};
